// libraries
import { createAsyncThunk } from '@reduxjs/toolkit';

// actions
import { RasActions } from '../actions';

// apis
import { riskAssessmentStatusApi } from '../apis/riskAssessmentStatus.api';

// models
import {
  ReqRiskAssessmentStatus,
  ResRiskAssessmentStatus
} from '../models/riskAssessmentStatus.model';

// common
import { ResultError } from 'modules/common';

/**
 * 위험 평가 상태 조회
 */
export const getRiskAssessmentStatusThunk = createAsyncThunk<
  ResRiskAssessmentStatus,
  ReqRiskAssessmentStatus,
  {
    rejectValue: ResultError;
  }
>(
  RasActions.GET_RISK_ASSESSMENT_STATUS,
  async (params: ReqRiskAssessmentStatus, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res: ResRiskAssessmentStatus =
        await riskAssessmentStatusApi.getRiskAssessmentStatus(params);

      return fulfillWithValue(res as ResRiskAssessmentStatus);
    } catch (error) {
      return rejectWithValue(error as ResultError);
    }
  }
);
